module.exports = __webpack_public_path__ + "static/media/home_mobile_tunnel.888b98d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_mobile_tunnel.png
// module id = 120
// module chunks = 0